import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';
import { createAppModal } from 'utils/modal';
import { FeedbackModalForm } from './components/form/feedbackForm';
import styles from './feedbackModal.module.scss';
/**
 * Represents the modal for customers to provide feedback to Dixa from within
 * the app.
 */
export const FeedbackModal = createAppModal({ type: 'app:feedbackForm' }, ({ isOpen, modal, hide, meta }) => {
    const handleClose = () => {
        if (meta) {
            hide === null || hide === void 0 ? void 0 : hide();
            meta.resolve({
                isSent: false,
                isCancelled: true,
                feedbackMessage: undefined,
            });
        }
    };
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.feedbackModal }, { children: [_jsx(ModalHead, { title: modal.arg.title, onClose: handleClose }), _jsx(ModalBody, { children: _jsx(FeedbackModalForm, {}) })] })));
});
